module.exports = __webpack_public_path__ + "img/icon-trending-down.4ff35253.svg";